import React, { Component } from 'react';

class ModalResultadoReemplazarCuentasContables extends Component {

    constructor(props) {
        super(props);
    }
    

    render() {
        const {
            cantidadModelos,
            cantidadRenglones,
            huboError,
            sagaId
        } = this.props;

        //ACTIONS
        const {
            mostrarOcultarModalConfirmarEliminacionRenglon
        } = this.props;

        let mensajeOk = "Transacción realizada con éxito. ";
        let modeloSingular = cantidadModelos == 1;
        let renglonSingular = cantidadRenglones == 1;

        mensajeOk += renglonSingular ? "Se actualizó " + cantidadRenglones + " renglón de " : "Se actualizaron " + cantidadRenglones + " renglones de "
        mensajeOk += modeloSingular ? cantidadModelos + " modelo contable." : cantidadModelos + " modelos contables.";

        return (
            <div className='modalContainer'>
                <div className='modalDemandaOutXS'>
                    <div className='modalConfirmarSalirTexto ABMModelos__modalResultadoReemplazarCuentasContables__textoResultado'>
                        {huboError ?
                            "Hubo un error durante la transacción, no fue posible actualizar las cuentas contables. Comuníquese con soporte para más información. [SagaId: " + sagaId.toString() + "]"
                        :
                            mensajeOk
                        }
                    </div>

                    <div className='modalProcesosFooterShort'>
                        <button onClick={() => mostrarOcultarModalConfirmarEliminacionRenglon("modalResultadoReemplazarCuentasContables", false)} className="btn btn-cta">Aceptar</button>
                    </div>
                </div>
            </div>

        )
    }
}

export default ModalResultadoReemplazarCuentasContables;
